import maDamagesTypes from '@/modules/Damage/views/damagesTypes'
import maDamagedItems from '@/modules/Damage/views/damagedItems'
import maDamagedParts from '@/modules/Damage/views/damagedParts'
import maDamagesDetails from '@/modules/Damage/views/damagesDetails'
import maDamagesView from '@/modules/Damage/views/damagesView'
import maDamagesConfirmed from '@/modules/Damage/views/damagesConfirmed'
import maDamagesExtraDetails from '@/modules/Damage/views/damagesExtraDetails'
import maDamageResultUptec from '@/modules/Damage/views/damageResultUptec'
import maDamageValidation from '@/modules/Damage/views/damageValidation'
import maDamageMobiler from '@/modules/Damage/views/damageMobilier'
import maDamageMobilerUptecFeature from '@/modules/Damage/views/damageMobilierUptecFeature'
import maDamageMobilerCategory1 from '@/modules/Damage/views/damageMobilierCategory1'
import maDamageMobilerCategory2 from '@/modules/Damage/views/damageMobilierCategory2'
import maDamageMobilerCategory3 from '@/modules/Damage/views/damageMobilierCategory3'
import maMultidamagedList from '@/modules/Damage/views/multidamageList'

export const damageRouter = [
  {
    path: '/damages-types/:user/:sinisterId/:propertyType/:warrantyId',
    name: 'damages-types',
    component: maDamagesTypes
  },
  {
    path: '/damaged-items/:user/:sinisterId/:propertyType/:damageType/:warrantyId',
    name: 'damaged-items',
    component: maDamagedItems
  },
  {
    path: '/damaged-parts/:user/:sinisterId/:propertyType/:damageType/:damagedItem/:warrantyId',
    name: 'damaged-parts',
    component: maDamagedParts
  },
  {
    path: '/damage-details/:user/:sinisterId/:propertyType/:damageType/:damagedItem/:warrantyId',
    name: 'damage-details',
    component: maDamagesDetails
  },
  {
    path: '/multidamage-list/:user/:sinisterId/:propertyType/:damageType/:damagedItem/:warrantyId',
    name: 'multidamage-list',
    component: maMultidamagedList
  },
  {
    path: '/damages-view/:user/:sinisterId/:warrantyId',
    name: 'damages-view',
    component: maDamagesView
  },
  {
    path: '/damages-confirmed/:user/:sinisterId/:warrantyId/',
    name: 'damage-confirmed',
    component: maDamagesConfirmed
  },
  {
    path: '/damage-extra-details/:user/:sinisterId/:warrantyId/:damageId',
    name: 'damage-extra-details',
    component: maDamagesExtraDetails
  },
  {
    path: '/damage-result-uptec/:user/:sinisterId/:propertyType/:damageType/:warrantyId/',
    name: 'damage-result-uptec',
    component: maDamageResultUptec
  },
  {
    path: '/damage-validation/:user/:sinisterId/:warrantyId/',
    name: 'damage-validation',
    component: maDamageValidation
  },
  {
    path: '/damage-validated/:user/:sinisterId/:warrantyId/',
    name: 'damage-validated',
    component: maDamageMobiler
  },
  {
    path: '/damage-mobilier/:user/:sinisterId/:propertyType/:damageType/:warrantyId/',
    name: 'damageMobilier',
    component: maDamageMobiler
  },
  {
    path: '/damage-mobilier-uptec/:user/:sinisterId/:propertyType/:damageType/:warrantyId/:productId',
    name: 'damageMobilierUptecFeature',
    component: maDamageMobilerUptecFeature
  },
  {
    path: '/damage-mobilier-category1/:user/:sinisterId/:propertyType/:damageType/:warrantyId/',
    name: 'damageMobilierCategory1',
    component: maDamageMobilerCategory1
  },
  {
    path: '/damage-mobilier-category2/:user/:sinisterId/:propertyType/:damageType/:warrantyId/',
    name: 'damageMobilierCategory2',
    component: maDamageMobilerCategory2
  },
  {
    path: '/damage-mobilier-category3/:user/:sinisterId/:propertyType/:damageType/:warrantyId/',
    name: 'damageMobilierCategory3',
    component: maDamageMobilerCategory3
  }
]
